import React from 'react';
import cn from 'classnames';
import classes from './summary.scss';
export const Summary = ({
  selectedTotal,
  budgetTotal,
  isInvalidTotal,
  amountColor,
  giveawayColor
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.title,
    style: {
      color: giveawayColor
    }
  }, "Your selected products"), /*#__PURE__*/React.createElement("span", {
    className: classes.budget
  }, "Total budget of ", budgetTotal), /*#__PURE__*/React.createElement("div", {
    className: classes.selected
  }, "Amount selected:\xA0", /*#__PURE__*/React.createElement("span", {
    className: cn(classes.total, {
      [classes.error]: isInvalidTotal
    }),
    style: {
      color: amountColor
    }
  }, selectedTotal))), /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }));
};